import React, { createContext, useContext, useEffect, useMemo, useState } from "react";

const STORAGE_KEY = "6amico_spatial_tpl_v1";

export const SPATIAL_TEMPLATES = [
  { id: "classico", label: "Classico", desc: "Brochure attuale" },
  { id: "aria", label: "Aria", desc: "Più spazio e respiro" },
  { id: "mappa", label: "Mappa", desc: "Griglia territorio" },
  { id: "editoriale", label: "Editoriale", desc: "Stile rivista" },
];

const ThemeLayoutContext = createContext(null);

export function ThemeLayoutProvider({ children }) {
  const [templateId, setTemplateId] = useState(() => {
    if (typeof window === "undefined") return "classico";
    return localStorage.getItem(STORAGE_KEY) || "classico";
  });

  useEffect(() => {
    localStorage.setItem(STORAGE_KEY, templateId);
  }, [templateId]);

  const shellClass = useMemo(
    () => `brochure-site spatial-tpl spatial-tpl-${templateId}`,
    [templateId],
  );

  const value = useMemo(
    () => ({ templateId, setTemplateId, shellClass, templates: SPATIAL_TEMPLATES }),
    [templateId, shellClass],
  );

  return (
    <ThemeLayoutContext.Provider value={value}>{children}</ThemeLayoutContext.Provider>
  );
}

export function useThemeLayout() {
  const ctx = useContext(ThemeLayoutContext);
  if (!ctx) throw new Error("useThemeLayout outside provider");
  return ctx;
}
